export default "__VITE_ASSET__CPEapTap__";